import { URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../../environments/environment';

export type SituacaoValidade =
  'NAO_SE_APLICA' | 'NAO_ENTREGUE' | 'NAO_INFORMADA' | 'VENCIDO' | 'VENCE_EM_BREVE' | 'VIGENTE';

export interface ItemChecklist {
  documentoId: number;
  descricao: string;
  recomendacao: string;
  link: string;
  ordem: number;
  exigeValidade: boolean;

  respostaId: number;
  entregue: boolean;
  status: string;
  /** As observações do edital: é o campo `justificativa` de `resposta_documento`. */
  observacoes: string;
  anexo: string;
  hashArquivo: string;
  dataEnvio: string;
  dataValidade: string;
  usuarioNome: string;

  situacaoValidade: SituacaoValidade;
  situacaoValidadeDescricao: string;
  /** Negativo quando já venceu; nulo quando não há data. */
  diasAteVencer: number;
}

export interface ResumoChecklist {
  total: number;
  entregues: number;
  pendentesDeEntrega: number;
  vencidos: number;
  vencendoEmBreve: number;
  semValidadeInformada: number;
  diasDeAlerta: number;
}

export interface Fase {
  nome: string;
  descricao: string;
}

/**
 * Checklist de documentos por fase (ADR-0010 §3.4).
 *
 * A lista vem completa do servidor mesmo quando nada foi entregue — é isso que o edital chama
 * de "espelhado automaticamente". Não há cópia do modelo para prestação nenhuma: todas
 * consultam o mesmo cadastro.
 */
@Injectable()
export class ChecklistDocumentosService {

  url: string;

  constructor(private http: AuthHttp) {
    this.url = `${environment.apiUrl}/checklist-documentos`;
  }

  daPrestacaoDeContas(celebracaoId: any)
    : Promise<{ resumo: ResumoChecklist, itens: ItemChecklist[] }> {

    const params = new URLSearchParams();
    params.set('celebracaoId', celebracaoId);

    return this.http.get(`${this.url}/prestacao-contas`, { search: params })
      .toPromise().then(r => r.json().dados);
  }

  porFase(celebracaoId: any, fase: string)
    : Promise<{ resumo: ResumoChecklist, itens: ItemChecklist[] }> {

    const params = new URLSearchParams();
    params.set('celebracaoId', celebracaoId);
    if (fase) { params.set('fase', fase); }

    return this.http.get(`${this.url}/por-fase`, { search: params })
      .toPromise().then(r => r.json().dados);
  }

  fases(): Promise<Fase[]> {
    return this.http.get(`${this.url}/fases`).toPromise().then(r => r.json().dados);
  }
}
